import { Stack, StackProps } from '@mui/material';

export const Group = (props: Omit<StackProps, 'direction'>) => {
  return <Stack direction="row" {...props} />;
};
